'use client'
import SecNav from 'components/privat/SecNav'
import Page from 'components/privat/Page'
import { usePrivateContext } from 'utils/context'

const secNav = [
  {
    id: 'yourTors',
    name: 'Els teus tornejos',
    link: '/privat/federat/competicio/els-teus-tornejos'
  },
  {
    id: 'openTors',
    name: 'Inscripcions obertes',
    link: '/privat/federat/competicio/inscripcions-obertes'
  }
]

const Layout = ({ children }) => {
  const { fedDetails } = usePrivateContext()
  return (
    <>
      {fedDetails?.PersonalInformation && (
        <SecNav
          items={
            fedDetails.PersonalInformation.SupportsCoach
              ? [
                  ...secNav,
                  {
                    id: 'coach',
                    name: 'Coach',
                    link: '/privat/federat/competicio/coach'
                  }
                ]
              : secNav
          }
          bg="sec-grey-4"
        />
      )}
      <Page>{children}</Page>
    </>
  )
}

export default Layout
